/**
* @ngdoc component
* @name returns.component:itxReturnForm
* @requires returns.service:SfiReturnsService
* @description
* This compontent shows:
* - IBAN: String alfanumérico de 24 caracteres. Ejemplo ES6621000418401234567891. Donde Los dos primeros caracteres son letras, que identifican el país de la cuenta, 
        para España ES. Los dos siguientes son números, que son dígitos de control para comprobar que no hay un error de marcaje. 
        Los 20 últimos son los correspondientes al CCC o Código de Cuenta Corriente.
* - BIC: String alfanumérico de entre 8 y 11 caracteres. Ejemplo BBVAESMM000 donde BBVA (entidad bancaria), ES (país, España), MADRID (Localidad) y 
        000 (código de sucursal)
* - Nombre: Nombre del cliente
* - Apellido: Primer apellido del cliente
* - País: Código ISO del país.
* 
*/
(function () {
    'use strict';

    var itxReturnForm = {
        bindings: {
            saveData: '<',
            orderPayment: '<',
            onRefundComplete: '&',
            order: '<'
        },
        controller: itxReturnFormCtrl,
        templateUrl: 'return-form.component.html'
    };

    itxReturnFormCtrl.$inject = ['SfiReturnsService', '$rootScope', 'CountryService', 'ItxTranslateSvc', 'AddressService', 'DUTTI_CONS'];

    function itxReturnFormCtrl(SfiReturnsService, $rootScope, CountryService, ItxTranslateSvc, AddressService, DUTTI_CONS) {
        var _this = this;

        _this.$onInit = function () {
            _this.formReady = false;
            _this.isEditable = true;
            _this.BillingAddress = {
                addressLines: []
            };
            _this.regexZipCode = '';
            _this.bankSelected = {};
            _this.getCountries();
            _this.getBillingAddress();

            inditex.getXConfigParameter('ZIPCODE_REGEXP_VALIDATION', function (regex) {
                if (regex && regex.value) {
                    _this.regexZipCode = regex.value;
                    $scope.$digest();
                }
            });

            // Colombia Account Types

            _this.accountTypes = SfiReturnsService.getAccountTypes();

            _this.buttonText = _this.saveData ? ItxTranslateSvc.translateCms('legacy.save') : ItxTranslateSvc.translateCms('legacy.send');

            _this.isRusia = CountryService.is(DUTTI_CONS.country.RU);
            _this.isUcrania = CountryService.is(DUTTI_CONS.country.UA);
            _this.isColombia = CountryService.is(DUTTI_CONS.country.CO);
            _this.isGeorgia = CountryService.is(DUTTI_CONS.country.GE);
            _this.isSerbia = CountryService.is(DUTTI_CONS.country.RS);
            _this.isBosnia = CountryService.is(DUTTI_CONS.country.BA);
            _this.isKazajistan = CountryService.is(DUTTI_CONS.country.KZ);
            _this.isIndonesia = CountryService.is(DUTTI_CONS.country.ID);
            _this.isArmenia = CountryService.is(DUTTI_CONS.country.AM);
            _this.isMacedonia = CountryService.is(DUTTI_CONS.country.MK);
            _this.isArabia = CountryService.is(DUTTI_CONS.country.SA);
            _this.isIndia = CountryService.is(DUTTI_CONS.country.IN);
            _this.isArgelia = CountryService.is(DUTTI_CONS.country.DZ);
            _this.isAzerbaiyan = CountryService.is(DUTTI_CONS.country.AZ);
            _this.isPhilipines = CountryService.is(DUTTI_CONS.country.PH);
            _this.model = SfiReturnsService.getInitialModel(_this.orderPayment);
            _this.model.documentTypeData = _this.model.documentType;
            _this.model.firstName = inditex.iUserJSON.firstName || '';
            _this.model.lastName = inditex.iUserJSON.lastName || '';
            _this.model.bankName = _this.isAzerbaiyan ? '' : undefined;
            _this.model.bankName = _this.isKazajistan ? '' : undefined;
            _this.model.bankList = _this.isAzerbaiyan ? '' : undefined;
            _this.showTooltip = _this.model.$pristine && !_this.isColombia && !_this.isUcrania;
            _this.formReady = true;
            _this.showBIC =
                !_this.isSerbia &&
                !_this.isBosnia &&
                !_this.isIndonesia &&
                !_this.isAzerbaiyan &&
                !_this.isGeorgia &&
                !_this.isArmenia &&
                !_this.isPhilipines;
            _this.showSelectedCountry = !_this.isSerbia && !_this.isIndonesia && !_this.isPhilipines && !_this.isAzerbaiyan;

            if (_this.isIndonesia) {
                // Bank List for Indonesia
                _this.getBankList();
            }

            if (_this.isArgelia) {
                _this.model.bankName = '';
            }

            if (_this.isPhilipines) {
                _this.model.bankName = '';
                _this.model.accountType = {};
            }

            if (_this.isDefined(_this.model.bankList)) {
                _this.bankList = [];
                _this.getBanks();
            }
            if (_this.isArabia) {
                _this.model.iban = 'SA';
            }
        };

        _this.getBanks = function () {
            let action = {
                action: 'GET_BANKS',
                params: {
                    languageId: inditex.iLangId,
                    storeId: inditex.iStoreId,
                    orderId: _this.order.id,
                    paymentMethodName: _this.orderPayment.kind.toUpperCase()
                }
            };

            joyr.rest
                .xRestExecute([action])
                .done(function (data) {
                    _this.bankList = data[0].banks || [];
                })
                .Catch(function (error) {
                    console.error('La API no está devolviendo bancos');
                });
        };

        _this.onChangeIdentDocument = function (identdoc) {
            _this.identdocSelected = identdoc;
            _this.model.documentTypeData = {
                documentType: identdoc.label,
                label: identdoc.label,
                type: identdoc.type
            };
        };

        _this.isDefined = function (field) {
            return typeof field != 'undefined';
        };

        _this.toggleEditable = function () {
            _this.isEditable = !_this.isEditable;
        };
        /**
         * @ngdoc method
         * @name onCountrySelected
         * @methodOf returns.component:itxReturnForm
         * @description
         * After country was selected from the country list, update the model.
         */
        _this.onCountrySelected = function (country) {
            _this.model.country.countryCode = country.countryCode;
            _this.model.country.countryName = country.countryName;
        };

        _this.onAccountTypeSelected = function (accountType) {
            _this.model.accountType.accountTypeName = accountType.name;
            _this.model.accountType.accountTypeCode = accountType.value;
        };
        /**
         * @ngdoc method
         * @name send
         * @methodOf returns.component:itxReturnForm
         * @description
         * If saveData input property is set to true, then only store the object
         * in the {@link returns.service:SfiReturnsService#setSfiObject} and make the form not editable.
         * Otherwise send the form to the API.
         */
        _this.send = function () {
            if (_this.model.$invalid || _this.model.$pristine) {
                return;
            }

            _this.model.iban = _this.model.iban ? _this.model.iban.toUpperCase() : _this.model.iban;
            _this.model.iban = _this.model.iban.replace(/ /g, '');

            _this.model.bic = _this.model.bic ? _this.model.bic.toUpperCase() : _this.model.bic;
            if (_this.isIndonesia) {
                _this.model.bic = _this.bankSelected.code;
                _this.model.bankName = _this.bankSelected.name;
            }

            _this.model.city = _this.BillingAddress.city;
            _this.model.address = _this.BillingAddress.addressLines[0];
            _this.model.zipCode = _this.BillingAddress.zipCode;

            if (_this.saveData) {
                SfiReturnsService.setSfiObject(_this.model);
                _this.toggleEditable();
                if (_this.isSerbia || _this.isBosnia) {
                    _this.saveAddress(_this.BillingAddress);
                }
                return;
            }

            if (!_this.saveData) {
                SfiReturnsService.sendRefundRequest(_this.model, _this.order.id)
                    .then(function (result) {
                        if (result) {
                            _this.onRefundComplete();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                return;
            }

            SfiReturnsService.sendReturnRequest(_this.model)
                .then(function (result) {
                    if (result) {
                        _this.onRefundComplete();
                    }
                })
                .finally(function () {});
        };

        _this.saveAddress = function (address) {
            AddressService.save(address)
                .then(function (result) {
                    _this.getBillingAddress();
                })
                .catch(function (error) {
                    console.error(error.errorMessage);
                });
        };

        _this.getBillingAddress = function () {
            AddressService.getBillingAddress().then(function (address) {
                _this.BillingAddress = address;
            });
        };

        _this.getCountries = function () {
            CountryService.getCountries().then(function (countries) {
                _this.countries = countries;
            });
        };

        _this.showFormParameter = function (parameter) {
            var country = inditex.iCountryCode;
            var showParameter = AddressService.getCountryFormParameters(country, parameter);
            return showParameter;
        };

        // Bank List for Indonesia
        _this.getBankList = function () {
            _this.bankList = SfiReturnsService.getBankList();
        };

        _this.onBankSelected = function (bank) {
            _this.bankSelected = bank;
            _this.model.iban = '';
            if (!_this.isIndonesia) {
                _this.model.bic = _this.bankSelected.parameters.replace('swiftCode=', '');
                _this.model.bankName = _this.bankSelected.bankName;
                _this.model.bankId = _this.bankSelected.bankId;
            }
        };
    }

    angular.module('itxApp.legacy').component('itxReturnForm', itxReturnForm);
})();
